module.exports = __webpack_public_path__ + "static/web_dev_photo-65098abea38890ada7960dff65ab936f.jpg";